var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChevronDownSmall = function SvgChevronDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.736 9.264a.9.9 0 00-1.272 0L12 13.727 7.536 9.264a.9.9 0 00-1.272 1.272l5.1 5.1a.9.9 0 001.272 0l5.1-5.1a.9.9 0 000-1.272z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43MzY0IDkuMjYzNjNDMTcuMzg0OSA4LjkxMjE2IDE2LjgxNTEgOC45MTIxNiAxNi40NjM2IDkuMjYzNjNMMTIgMTMuNzI3Mkw3LjUzNjM5IDkuMjYzNjNDNy4xODQ5MiA4LjkxMjE2IDYuNjE1MDcgOC45MTIxNiA2LjI2MzYgOS4yNjM2M0M1LjkxMjEzIDkuNjE1MSA1LjkxMjEzIDEwLjE4NSA2LjI2MzYgMTAuNTM2NEwxMS4zNjM2IDE1LjYzNjRDMTEuNzE1MSAxNS45ODc5IDEyLjI4NSAxNS45ODc5IDEyLjYzNjQgMTUuNjM2NEwxNy43MzY0IDEwLjUzNjRDMTguMDg3OSAxMC4xODQ5IDE4LjA4NzkgOS42MTUxIDE3LjczNjQgOS4yNjM2M1oiIGZpbGw9IiMwMjNGODAiLz4KPC9zdmc+Cg==";
export { SvgChevronDownSmall as ReactComponent };